import { z } from 'zod';

export const EnvironmentVariablesSchema = z.object({
    DEMO_API_KEY: z.string().optional(),
    STRIPE_PUBLIC_KEY: z.string().default('not not set'),
});
